import type { Company } from "@/services/api/types";

type CompanyOption = {
  id: string;
  label: string;
  disabled?: boolean;
};

export const sortCompanies = (companies: Company[]): CompanyOption[] => {
  companies.sort((a, b) => {
    if (a.companyName < b.companyName) return -1;
    if (a.companyName > b.companyName) return 1;
    return 0;
  });

  return companies.map((company) => ({
    id: company.companyKey,
    label: company.companyName,
  })); 
};
